import request from "@/api/request";

export function search(data) {
    return request({
        url: '/salary/search',
        method: 'post',
        data: data
    })
}


export function info(query) {
    return request({
        url: '/salary/info',
        method: 'get',
        params: query
    })
}

//新一线城市
export function newCity() {
    return request({
        url: '/salary/newCitys',
        method: 'get'
    })
}

//职位
export function positionConfigList() {
    return request({
        url: '/salary/position',
        method: 'get'
    })
}

//热门职位
export function hotPosition() {
    return request({
        url: '/salary/hotPosition',
        method: 'get'
    })
}

//https://m.zhipin.com/wapi/zpboss/h5/marketpay/statistics.json?positionId=100101&cityId=0&experienceCode=103
export function statistics(data) {
    return request({
        url: '/salary/statistics',
        method: 'post',
        data: data
    })
}


